import { LineReveal, Reveal } from "@/components/Reveal";

// Inner-page hero header with overline + big serif title.
export default function PageHero({ overline, titleLines = [], subtitle }) {
  return (
    <section className="pt-16 md:pt-24 pb-8 md:pb-12 border-b border-brand-ink/10">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        {overline && (
          <Reveal>
            <span className="text-xs md:text-sm uppercase tracking-[0.24em] text-brand-red font-medium">
              {overline}
            </span>
          </Reveal>
        )}
        <h1 className="mt-5 font-display text-5xl md:text-7xl lg:text-[7vw] leading-[0.95] tracking-tight text-brand-ink">
          <LineReveal lines={titleLines} />
        </h1>
        {subtitle && (
          <Reveal delay={0.3}>
            <p className="mt-6 max-w-2xl text-lg md:text-xl leading-relaxed text-muted-foreground">
              {subtitle}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
